import StoreService from './store_svc';
import store from 'approot/app/store';

export function handleCustomerType(storeData) {
	let customer_group = 'general';
	const customerCurrentSegmentCode = storeData?.onboardView?.customerCurrentSegmentCode;
	if (customerCurrentSegmentCode === 'J') {
		customer_group = 'jade';
	} else if (customerCurrentSegmentCode === 'P') {
		customer_group = 'premier';
	} else if (customerCurrentSegmentCode === 'A') {
		customer_group = 'advance';
	} else if (customerCurrentSegmentCode === 'R') {
		customer_group = 'retail';
	}
	return customer_group;
}

export function tmsTrackView(paramsObj) {
	if (!window.TMS) { 
		return; 
	}
	const storeData = StoreService?.getStore()?.getState();
	// customer type logic begin.
	const customer_group = handleCustomerType(storeData);
	// customer type logic end.
	const { session } = store.getState();
	const { page_url_category,
		raw_datalayer, pageSubcategory,
		funnel_name, funnel_step, funnel_step_name, form_field_1, form_field_2, form_field_8, del_site_brand_site_country_site_region
	} = paramsObj;
	const page_url = page_url_category ?
		'/wealth-dashboard/esg questionnaire/' + page_url_category : '/wealth-dashboard/esg questionnaire/landing-page';
	const page_name = 'ib:wealth dashboard:esg questionnaire:' + pageSubcategory;
	let trackViewObj = {
		page_url,
		site_section: 'ib',
		page_language: session.locale === 'en_US' ? 'en_HK' : session.locale,
		page_type: 'transaction',
		page_customer_group: 'general',
		customer_group,
		page_business_line: 'rbwm',
		page_security_level: '30',
		page_name,
		page_category: 'wealth dashboard',
		page_subcategory: 'esg questionnaire',
		raw_datalayer,
		product_category: 'wealth management'
	};

	trackViewObj = funnel_name ? { ...trackViewObj, funnel_name } : trackViewObj;
	trackViewObj = funnel_step ? { ...trackViewObj, funnel_step } : trackViewObj;
	trackViewObj = funnel_step_name ? { ...trackViewObj, funnel_step_name } : trackViewObj;
	trackViewObj = form_field_1 ? { ...trackViewObj, form_field_1 } : trackViewObj;
	trackViewObj = form_field_2 ? { ...trackViewObj, form_field_2 } : trackViewObj;
	trackViewObj = form_field_8 ? { ...trackViewObj, form_field_8 } : trackViewObj;
	if (!del_site_brand_site_country_site_region) {
		trackViewObj = {
			...trackViewObj,
			site_brand: 'hsbc',
			site_country: 'hong kong',
			site_region: 'asia pacific'
		};
	}

	window.TMS.trackView(trackViewObj);
}

export function tmsTrackEvent(paramsObj) {
	if (!window.TMS) { 
		return; 
	}
	const storeData = StoreService?.getStore()?.getState();
	// customer type logic begin.
	const customer_group = handleCustomerType(storeData);
	// customer type logic end.

	const { session } = store.getState();

	const { page_url_category,
		event_category, event_action, event_content, pageSubcategory, raw_datalayer,
		funnel_name, funnel_step, funnel_step_name, form_field_1, form_field_2, form_field_4, form_field_5, form_field_6, form_field_7, form_field_8, del_site_brand_site_country_site_region
	} = paramsObj;
	const page_url = page_url_category ?
		'/wealth-dashboard/esg questionnaire/' + page_url_category : '/wealth-dashboard/esg questionnaire/landing-page';
	const page_name = 'ib:wealth dashboard:esg questionnaire:' + pageSubcategory;
	let trackEventObj = {
		page_url,
		event_category: event_category ?? 'content',
		event_action,
		event_content,
		site_section: 'ib',
		page_language: session.locale === 'en_US' ? 'en_HK' : session.locale,
		page_type: 'transaction',
		page_customer_group: 'general',
		customer_group,
		page_business_line: 'rbwm',
		page_security_level: '30',
		page_name,
		page_category: 'wealth dashboard',
		page_subcategory: 'esg questionnaire',
		raw_datalayer,
		product_category: 'wealth management'
	};

	trackEventObj = funnel_name ? { ...trackEventObj, funnel_name } : trackEventObj;
	trackEventObj = funnel_step ? { ...trackEventObj, funnel_step } : trackEventObj;
	trackEventObj = funnel_step_name ? { ...trackEventObj, funnel_step_name } : trackEventObj;
	trackEventObj = form_field_1 ? { ...trackEventObj, form_field_1 } : trackEventObj;
	trackEventObj = form_field_2 ? { ...trackEventObj, form_field_2 } : trackEventObj;
	trackEventObj = form_field_4 ? { ...trackEventObj, form_field_4 } : trackEventObj;
	trackEventObj = form_field_5 ? { ...trackEventObj, form_field_5 } : trackEventObj;
	trackEventObj = form_field_6 ? { ...trackEventObj, form_field_6 } : trackEventObj;
	trackEventObj = form_field_7 ? { ...trackEventObj, form_field_7 } : trackEventObj;
	trackEventObj = form_field_8 ? { ...trackEventObj, form_field_8 } : trackEventObj;
	if (!del_site_brand_site_country_site_region) {
		trackEventObj = {
			...trackEventObj,
			site_brand: 'hsbc',
			site_country: 'hong kong',
			site_region: 'asia pacific'
		};
	}

	window.TMS.trackEvent(trackEventObj);

}
